import styles from './separationLine.module.scss';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

export const SeparationLine: React.FC<{
  bold?: boolean;
  className?: string;
}> = ({ bold = true, className }) => {
  const separationLineClass = cx(styles.separationLine, className, {
    bold
  });
  return <div className={separationLineClass} />;
};
